import { registerPlugin } from '@capacitor/core';

export interface NotificationStatusPlugin {
  /**
   * Devuelve si las notificaciones están habilitadas a nivel del sistema operativo.
   * Refleja la desactivación manual del usuario en cualquier versión de Android
   * (a diferencia de PushNotifications.checkPermissions() en Android < 13).
   * Solo implementado en Android.
   */
  areEnabled(): Promise<{ enabled: boolean }>;
}

export const NotificationStatus = registerPlugin<NotificationStatusPlugin>('NotificationStatus');
